import jMoment from "jalali-moment";
import convertNumbers2English from "./convertNumbers2English";
type props = {
  date: any;
  format?: string;
};
function convertJalaliToGregorian({ date, format = "YYYY-MM-DD" }: props) {
  return jMoment
    .from(convertNumbers2English(date), "fa", format)
    .format(format);
}
export default convertJalaliToGregorian;
